var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#373A36;} \n\t.minus{stroke:#373A36;}\n\t.st1{fill:#9C4877;}\n\t.st2{fill:#F8F8F7;}\n\t.st3{fill:#E2E2DC;}\n\t.st4{fill:#E64B38;}\n\t.st5{fill:#EFB8A9;}\n\t.st6{fill:none;stroke:#CCCCCC;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st7{fill:#FFC557;}\n\t.st8{fill:none;stroke:#373A36;stroke-width:0.4213;stroke-miterlimit:10;}\n\t.st9{fill:#4A9462;}\n\t.st10{fill:none;stroke:#F8F8F7;stroke-width:0.5;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},React.createElement("rect",{"y":"0.836","className":"st0 minus","width":"27.53","height":"0.5"}))]);
}

Minus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 27.53 2.171","style":{"enableBackground":"new 0 0 27.53 2.171"},"xmlSpace":"preserve"};

module.exports = Minus;

Minus.default = Minus;
